(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbd-section-1"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.view_more_link').length > 0){
        document.querySelectorAll('.view_more_link').forEach(function(elem){
            elem.onclick = function(){
                if(elem.classList.contains('showing-all')){
                    elem.parentElement.classList.remove('show-all');
                    elem.textContent = 'View More';
                }
                else{
                    elem.parentElement.classList.add('show-all');
                    elem.textContent = 'View Less';
                }
                elem.classList.toggle('showing-all');
            }
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.tab-button').length > 0){
      const tabs = document.querySelectorAll('.tab-button');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.footer__block--menu-title').forEach(element => {
      element.onclick = function(){
        if(window.innerWidth < 750){
          let isOpen = false;
          if(element.parentElement.classList.contains('open')){
            isOpen = true;
          }
          if(document.querySelector('.footer__block--menu.open'))
            document.querySelector('.footer__block--menu.open').classList.remove('open');

          if(isOpen)
            element.parentElement.classList.remove('open');
          else
            element.parentElement.classList.toggle('open');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glossary"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.alphabet-tab').length > 0){
      const tabs = document.querySelectorAll('.alphabet-tab');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-target'));
                console.log(section);
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.faq-question').forEach(function(elem){
        elem.onclick = function(){
            let superParent = elem.closest('.product-faq-section');
            if(superParent.querySelector('.product-faq-block.open')){
                if(superParent.querySelector('.product-faq-block') != elem.parentElement){
                    superParent.querySelector('.product-faq-block.open').classList.remove('open');
                }
            }
            elem.parentElement.classList.toggle('open');
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-list').forEach(function(elem){
        elem.querySelectorAll('.video-card').forEach(function(card){
            card.querySelector('.video-sound-btn').addEventListener('click', function(e) {
                e.preventDefault();
                let videoElement = card.getElementsByTagName('video')[0];
                let cardParent = card.closest('.video-blocks-wrap');
                if(card.classList.contains('muted')){
                    videoElement.muted = true;
                }
                else{
                    if(cardParent.querySelector('.video-card.muted')){
                        cardParent.querySelector('.video-card.muted').querySelector('video').muted = true;
                        cardParent.querySelector('.video-card.muted').classList.remove('muted');
                    }
                    videoElement.muted = false;
                }
                card.classList.toggle('muted');
                });
        });

        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            cssMode: true,
            mousewheel: { forceToAxis: true },
            breakpoints: {
              700:  { spaceBetween: 12, centeredSlides: false, loop: false }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virtual-consults"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.consultation-blocks-wrap').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            cssMode: true,
            loop: true,
            centeredSlides: true,
            mousewheel: { forceToAxis: true },
            breakpoints: {
              700: { spaceBetween: 16, loop: false, centeredSlides: false, },
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();
})();
